export function exportTableDataToCSV(tableInstance, filename = "export.csv", options = {}) {
  const table = tableInstance.table
  const state = table.getState();
  const { emptyValue = "-" } = options;

  const leafColumns = table
    .getAllLeafColumns()
    .filter((col) => col.id !== "select")
    .filter((col) => col.id !== "connect")
    .filter((col) => state.columnVisibility[col.id] !== false)
    .sort(
      (a, b) =>
        state.columnOrder.indexOf(a.id) -
        state.columnOrder.indexOf(b.id)
    );

  const header = leafColumns
    .map((col) => {
      const h = col.columnDef.header;
      return typeof h === "string" ? h : col.id;
    })
    .join(",");

  const rows = table.getPrePaginationRowModel().rows;

  const data = rows
    .map((row) =>
      leafColumns
        .map((col) => {
          let value;

          if (col.columnDef.meta?.exportValue) {
            value = col.columnDef.meta.exportValue({ row });
          } else {
            value = row.getValue(col.id);
          }

          if (value === null || value === undefined || value === "-") value = emptyValue;
          else if (Array.isArray(value)) value = value.join(", ");
          else value = String(value);

          value = value.replace(/"/g, '""');
          return `"${value}"`;
        })
        .join(",")
    )
    .join("\n");

  const csvContent = [header, data].join("\n");

  const blob = new Blob([csvContent], {
    type: "text/csv;charset=utf-8;",
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
